const OBJECT_TYPE = "[object Object]";
const $type = Function.prototype.call.bind(Object.prototype.toString);

export function isPlainObject(value) {
    return typeof value === "object" && $type(value) === OBJECT_TYPE;
}

export function formatMoney(amount) {
    return amount ? amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "0.00";
}

export function isValidPhoneNumber(phoneNumber, digit) {
    if (digit) {
        return /[0-9 +]{5,16}$/.test(phoneNumber);
    }
    else return /[0-9 +]{9,16}$/.test(phoneNumber);
}

// Need an opportunity to auto-initialize
// We will then, in such window, schedule an autoInitialize action on the nextTick()
export const autoInitialize = (() => {
    let activeView = null;

    let firstPaymentAutoInitializePrevented = false;

    const preventAutoInitializeWhenFirst = [
        "BANK_TRANSFER_INIT_VIEW", 
        "NQR_INIT_VIEW",
        "BANK_INIT_VIEW",
        "GOOGLEPAY_INIT_VIEW",
        "APPLEPAY_INIT_VIEW",
        "OPAY_INIT_VIEW",
    ];


    const activateCurrentView = (currentView) => {
        if (firstPaymentAutoInitializePrevented !== true) {
            firstPaymentAutoInitializePrevented = true;
        }
        activeView = currentView;        
    };


    const getCurrentView = stateRef => (
        stateRef.value.view != undefined
            ? stateRef.value.view.current || null
            : null
    );

    addEventListener("on:CurrentViewChange", ({ detail: currentView }) => {
        setTimeout(activateCurrentView, 0, currentView);
    });
	
    return (...views) => (stateRef, initialize, constraints) => {
        const currentView = getCurrentView(stateRef);
		
        if (currentView && currentView !== activeView) {
            if (
                stateRef.value.processing !== true &&
				views.includes(currentView) && 
                (typeof constraints === "function" ? constraints(stateRef) : true)
            ) { 
                if (
                    (!preventAutoInitializeWhenFirst.includes(currentView) ||
                    firstPaymentAutoInitializePrevented === true || (stateRef.value.method.initial !== stateRef.value.method.current))
                ) {
                    initialize();
                } 

                activateCurrentView(currentView);
            }
        }
    };
})();

export const anHourFromNow = (() => {
    const pad = num => `0${num}`.slice(-2);
    const parse = num => Math.max(~~parseFloat(num), 0);
    const meridian = hour => ["AM", "PM"][+(hour >= 12)];
    const tomorrow = date => date.getDate() > new Date().getDate();
    // const timezone = date => `GMT+${-(date.getTimezoneOffset() / 60)}`
    // // .replace(/\+?([-+])/, "$1");
    //     .replace(/\+?([-+])(\d+)/, (_, $1, $2) => +$2 ? `${$1}${$2}` : "");
  
    return (offset) => {
        const date = new Date(Date.now() + (3600 - parse(offset)) * 1000);
        const minute = date.getMinutes();
        const hour = date.getHours();
  
        // return `${[
        //     pad(hour > 12 ? hour % 12 : hour),
        //     pad(minute),
        // ].join(":")} ${meridian(hour)} (${timezone(date)}) ${tomorrow(date) ? "tomorrow" : "today"}`;

        return `${[
            pad(hour > 12 ? hour % 12 : hour),
            pad(minute),
        ].join(":")} ${meridian(hour)} (${tomorrow(date) ? "tomorrow" : "today"})`;
    };
})();

export const customExpiryTime = (() => {
    const pad = num => `0${num}`.slice(-2);
    // const parse = num => Math.max(~~parseFloat(num), 0);
    const meridian = hour => ["AM", "PM"][+(hour >= 12)];
    const inTheFuture = date => { 
        if (date.getFullYear() === new Date().getFullYear()) {
            return date.getDate() > new Date().getDate();
        } 
        else if (date.getFullYear() > new Date().getFullYear()) {
            return true;
        }
    };

    return (expiryTime) => {
        const date = new Date(Date.now() + (expiryTime) * 1000);
        const minute = date.getMinutes();
        const hour = date.getHours();

        return `${[
            pad(hour > 12 ? hour % 12 : hour),
            pad(minute),
        ].join(":")} ${meridian(hour)} (${inTheFuture(date) ? formatToReadableDate(date) : "today"})`;
    };
})();

function formatToReadableDate(date) {
    let month = date.toLocaleString("default", { month: "short" });
    let year = date.getFullYear();
    let dayDate = date.getDate();

    const currentDate = new Date().getDate();
    const diff = dayDate - currentDate;

    return diff === 1 ? "tomorrow" : `on ${month} ${dayDate}, ${year}`;
}

export function getValueFromPath(object, path) {
    // Ensure that path is a string, default to an empty string if not provided.
    // Replace bracket notation occurrences on path with dot notation.
    // Split path (to array) using the `.` delimeter, discard empty elements.
    path = (path ? String(path) : String())
        .replace(/\[((?:['"])?)([^[\]]*)\1\]/g, function __replacer__($, $$, key) {
            return `.${Number(key) || String(key)}`;
        })
        .split(/\.+/)
        .filter(Boolean);

    // Value is originally the root object.
    let value = object;

    // For every key in the path array, try to access the value at that address.
    // Update `value` with the value at that address.
    // Break the loop if `value` is `undefined`.
    for (const key of path) {
    // If value is an object instance or plain JS object and has the given key,
    // access the given key on the object. Otherwise, if it is an array, try to
    // access the numeric key(index) on the array. Otherwise, it is `undefined`.
        try {
            value = (value instanceof Object || isPlainObject(value)) && key in value
                ? value[key]
                : value[value instanceof Array ? Number(key) : key];

            if (value === undefined) break;
        }
        catch (e) {
            value = undefined;
            break;
        }
    }

    return value;
}
export function getCodeFromString(data, type) {
    // eslint-disable-next-line no-useless-escape
    let instruction = "";
    if (type == "momo") {
        const ussdCode = data.match(/[*#][\d*#]+[*#]/g);
        instruction = data.replace(/[*#][\d*#]+[*#]/, `<a href="tel://${ussdCode}" rel="nofollow">${ussdCode}</a>`);
    }
    else {
    // eslint-disable-next-line no-unused-vars
        const [, ussdCode, referenceCode] = data.match(/((?:\*\d+)+#)(?:\|(\d+))?/) || [];
        instruction = data.replace(/((?:\*\d+)+#)(?:\|(\d+))?/, `<a href="tel://${ussdCode}" rel="nofollow">${ussdCode}</a>`);
    }
    return instruction;
}
export function SelectBox($select) {
    try {
        if (
            $select instanceof HTMLSelectElement &&
      $select.classList.contains("selectbox__native")
        ) {
            if (!(this instanceof SelectBox)) {
                return new SelectBox($select);
            }

            const $container = $select.closest(".selectbox");
            if ($container && $container !== $select) {
                this.$select = $select;
                this.$options = $select.options;
                this.$container = $container;

                this.$updatePlaceholder = this.updatePlaceholder.bind(this);

                $select.addEventListener(
                    "change",
                    this.$updatePlaceholder,
                    false,
                );

                this.updateElements();
            }
            else throw new Error();
        }
        else throw new Error();
    }
    catch (e) {
        console.log(e);
        throw new Error(
            "Expects a <select> element that meets all selectbox requirements.",
        );
    }
}

// Augment SelectBox prototype with helpful methods
Object.defineProperties(SelectBox.prototype, {
    updateElements: {
        value() {
            const $select = this.$container.querySelector(
                "select.selectbox__native",
            );
            const $placeholder = this.$container.querySelector(
                ".selectbox__placeholder",
            );

            if ($select && $placeholder) {
                if (this.$select !== $select) {
                    $select.addEventListener(
                        "change",
                        this.$updatePlaceholder,
                        false,
                    );
                    this.$select.removeEventListener(
                        "change",
                        this.$updatePlaceholder,
                        false,
                    );
                    this.$select = $select;
                    this.$options = $select.options;
                }

                if (this.$placeholder !== $placeholder) {
                    this.$placeholder = $placeholder;
                }
                this.updatePlaceholder();
            }
        },
    },
    updatePlaceholder: {
        value() {
            const text = this.$options[this.$select.selectedIndex].textContent;
            if (text !== this.$placeholder.textContent) {
                this.$placeholder.textContent = text;
            }
        },
    },
});

export function fetchTranslatedString(jsonFile, searchString) {
    if (jsonFile && typeof jsonFile === "object") {
        let translatedMessage;
        for (const [key, value] of Object.entries(jsonFile)) {
            if (key === searchString) {
                translatedMessage = value;
            }
        }

        return translatedMessage;
    }
}